export const breadcrumb = {
  remove: group => {
    const arr = breadcrumb.get()
    arr.length = arr.findIndex(item => item._id === group._id) + 1
    breadcrumb.save(arr)
  },
  reset: () => breadcrumb.save([]),
  add: group => breadcrumb.save(breadcrumb.get().concat([group])),
  get: () => JSON.parse(sessionStorage.groupsBreadcrumb || '[]'),
  save: groups => (sessionStorage.groupsBreadcrumb = JSON.stringify(groups)),
}
